import { SxProps, Theme } from '@mui/material'

/** Horizontal/vertical padding of the theme's text buttons, offset so the label lines up with the cell text. */
const BUTTON_OFFSET_LEFT = '-12px'
const BUTTON_OFFSET_TOP = '-8px'
const ICON_BUTTON_OFFSET_BLOCK = '-4px'

/**
 * Shared layout of the read-only tables on the installation details page.
 */
export const getCompactTableSx = (offsetLeft?: number): SxProps<Theme> => ({
  '& .container-root table': {
    width: offsetLeft ? (theme: Theme) => `calc(100% + ${theme.spacing(Math.abs(offsetLeft))})` : '100%',
    ...(offsetLeft ? { marginLeft: offsetLeft } : {}),
  },
  '& .container-root th, & .container-root td': {
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
  },
  '& .container-root th:last-of-type, & .container-root td:last-of-type': {
    width: '100%',
  },
})

/** Wrapper style for a text button placed in a table cell: its label starts where the cell text starts. */
export const tableCellButtonSx: SxProps<Theme> = {
  display: 'flex',
  marginLeft: BUTTON_OFFSET_LEFT,
  marginTop: BUTTON_OFFSET_TOP,
}

/** Style for an icon button placed next to cell text: it does not make the row taller than the text. */
export const tableCellIconButtonSx: SxProps<Theme> = {
  marginBlock: ICON_BUTTON_OFFSET_BLOCK,
}
